// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const EyeActive: React.FC = () => {
    return <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 11.9 13.8" color="currentColor" fill="currentColor">
	<circle cx="5.9" cy="6.9" r="1.6"/>
	<path d="M11.7,6.5c-1.4-2.1-3.6-3.3-5.8-3.2-2.2,0-4.4,1.2-5.8,3.2-.2.3-.2.6,0,.9,1.4,2.1,3.6,3.3,5.8,3.2,2.2,0,4.4-1.2,5.8-3.2.2-.3.2-.6,0-.9ZM5.9,9.4c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5,2.5,1.1,2.5,2.5h0c0,1.4-1.1,2.5-2.5,2.5Z"/>
  </svg>;
};

export default React.memo(EyeActive);
